import { getClasses } from "../../utils";
import classes from "./InputLabel.module.css";

type Props = {
  label: string;
  className?: string;
  style?: React.CSSProperties;
  isInvalid?: boolean;
  invalidText?: string;
  optional?: boolean;
};

const InputLabel: React.FC<Props> = ({
  label,
  className = "",
  style,
  invalidText,
  isInvalid,
  optional = false
}) => {
  return (
    <div style={style} className={getClasses(classes.label, className)}>
      {label}
      {isInvalid !== undefined && !optional && (
        <sup>
          <span className={classes.asterisk}>*</span>
        </sup>
      )}
      {
        optional && <span className={classes.optionaText}>{`(Optional)`}</span>
      }
      {isInvalid && invalidText && (
        <div className={classes.errorText}>{invalidText}</div>
      )}
    </div>
  );
};

export default InputLabel;
